(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mountain-trail"] && !Shopify.designMode) return;
  try {
    
function initializeMountainTrailGuides() {
  document.querySelectorAll('[data-mt-guide]').forEach((guide) => {
    if (guide.dataset.initialized) return;
    guide.dataset.initialized = 'true';
    const tabs = Array.from(guide.querySelectorAll('[data-mt-tab]'));
    const panels = Array.from(guide.querySelectorAll('[data-mt-panel]'));
    function activate(tab) {
      tabs.forEach((item) => { const selected = item === tab; item.setAttribute('aria-selected', String(selected)); item.tabIndex = selected ? 0 : -1; });
      panels.forEach((panel) => { panel.hidden = panel.dataset.mtPanel !== tab.dataset.mtTab; });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        let next;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault(); activate(tabs[next]); tabs[next].focus();
      });
    });
  });
}
initializeMountainTrailGuides();
document.addEventListener('shopify:section:load', initializeMountainTrailGuides);

  } catch(e) { console.error(e); }
})();
})();
